// Shared namespace for global agents, independent of any workspace.
export const GLOBAL_AGENTS_WORKSPACE_ID = "global";
export const MAX_AGENT_SEARCH_RESULTS = 100;
